import { useLayoutEffect, useRef, useState } from "react";

export default function ExpandableText({ text, lines = 2, className = "", testid }) {
  const [expanded, setExpanded] = useState(false);
  const [overflows, setOverflows] = useState(false);
  const ref = useRef(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (el && !expanded) setOverflows(el.scrollHeight > el.clientHeight + 1);
  }, [text, expanded, lines]);

  if (!text) return null;
  return (
    <div>
      <p ref={ref} data-testid={testid} className={className}
        style={expanded ? undefined : { display: "-webkit-box", WebkitLineClamp: lines, WebkitBoxOrient: "vertical", overflow: "hidden" }}>
        {text}
      </p>
      {(overflows || expanded) && (
        <button type="button" data-testid={testid ? `${testid}-toggle` : undefined}
          onClick={(e) => { e.stopPropagation(); setExpanded(!expanded); }}
          className="mt-1 text-[10px] font-bold uppercase tracking-[0.15em] text-pb-cyan hover:text-[#BEF264] transition-colors">
          {expanded ? "Show less" : "Show more"}
        </button>
      )}
    </div>
  );
}
